import { Translation, QRType } from '../types';

export const ru: Translation = {
  nav: {
    generator: 'Генератор',
    scanner: 'Сканер',
    mobile: 'Попробовать на телефоне',
    blog: 'Блог',
    langSelect: 'Выбрать язык',
  },
  pageTitles: {
    generator: 'Бесплатный онлайн‑генератор QR‑кодов',
    scanner: 'Онлайн‑сканер QR‑кодов',
    textToQr: 'Текст в QR‑код',
    linkToQr: 'Ссылка в QR‑код',
  },
  pageMeta: {
    generator: {
      title:
        'Бесплатный генератор QR‑кодов — создавайте QR‑коды онлайн (без регистрации, без водяных знаков, PNG/SVG/PDF) | YesQRCode',
      description:
        'Создавайте QR‑коды онлайн бесплатно с YesQRCode. Генерируйте URL, текст, Wi‑Fi, vCard и многое другое. Скачивайте PNG, SVG или PDF высокого качества. Без регистрации, без входа, без водяных знаков — быстро, безопасно и бесплатно навсегда.',
      keywords: [
        'генератор qr кодов',
        'бесплатный генератор qr кодов',
        'создать qr код онлайн',
        'создатель qr кода',
        'qr код png',
        'qr код svg',
        'qr код pdf',
        'qr код wifi генератор',
        'qr код vcard генератор',
        'qr генератор без регистрации',
      ],
    },
    scanner: {
      title:
        'Онлайн‑сканер QR‑кодов — сканирование из изображения или камеры (безопасно, без регистрации) | YesQRCode',
      description:
        'Сканируйте QR‑коды и штрих‑коды онлайн бесплатно. Загрузите изображение или используйте камеру. Вся обработка выполняется локально без загрузок. Быстро, безопасно, без регистрации и полностью бесплатно.',
      keywords: [
        'сканер qr кодов',
        'сканировать qr онлайн',
        'онлайн qr ридер',
        'сканировать qr с изображения',
        'сканировать штрихкод онлайн',
        'безопасный сканер qr',
        'сканер qr без загрузки',
        'бесплатный сканер qr',
        'сканер qr в браузере',
        'сканер qr без регистрации',
      ],
    },
    textToQr: {
      title: 'Текст в QR | Превратите заметки в QR‑коды',
      description:
        'Преобразуйте фрагменты текста, заметки или сообщения в QR‑коды для обмена. Настройте дизайн и экспортируйте в PNG, SVG или PDF мгновенно без регистрации.',
      keywords: ['текст в qr', 'генератор qr текст', 'qr код заметка', 'qr сообщение', 'онлайн конвертер qr', 'бесплатный qr текст'],
    },
    linkToQr: {
      title: 'Ссылка в QR | Превратите URL в QR‑код',
      description:
        'Вставьте любой URL сайта или кампании и сразу создайте брендированный QR‑код для печати или цифрового использования. Поддерживаются цвета, логотипы и загрузки высокого разрешения.',
      keywords: ['ссылка в qr', 'qr код url генератор', 'qr для сайта', 'qr для ссылки', 'utm qr код', 'скачать qr pdf'],
    },
  },
  hero: {
    title: 'Создавайте приватные, бренд‑готовые QR‑коды — бесплатно навсегда.',
    subtitle: 'Быстрый, приватный и гибкий QR‑инструмент для любого процесса.',
    desc: 'Генерируйте и сканируйте QR‑коды высокого качества без аккаунтов, водяных знаков и загрузки данных.',
    ctaPrimary: 'Создать QR‑код',
    ctaSecondary: 'Попробовать на телефоне',
  },
  info: {
    helpTitle: 'Центр поддержки',
    helpSubtitle: 'FAQ и помощь',
    contactTitle: 'Связаться с нами',
    contactSubtitle: 'Мы будем рады вашему сообщению.',
    privacyTitle: 'Политика конфиденциальности',
    termsTitle: 'Условия обслуживания',
  },
  contactForm: {
    name: 'Имя',
    email: 'Email',
    message: 'Сообщение',
    send: 'Отправить',
    orEmail: 'или напишите нам напрямую на',
    sending: 'Отправка...',
    successTitle: 'Сообщение отправлено!',
    successMessage: 'Спасибо! Мы ответим вам в ближайшее время.',
    sendAnother: 'Отправить ещё одно сообщение',
    errorMessage: 'Сейчас не удалось отправить сообщение. Пожалуйста, напишите на support@yesqrcode.com.',
  },
  generator: {
    highlights: {
      title: 'Создавайте приватные, бренд‑готовые QR‑коды — бесплатно навсегда.',
      subtitle: 'Быстрый, приватный и гибкий QR‑инструмент для любого процесса.',
      items: [
        {
          title: 'Приватность прежде всего, генерация на устройстве',
          desc: 'QR‑коды создаются локально — без загрузок, трекинга и хранения данных.',
        },
        {
          title: 'Богатые возможности для любого сценария',
          desc: 'URL, Wi‑Fi, vCard, штрих‑коды, логотипы, градиенты, рамки — всё встроено.',
        },
        {
          title: 'Удобно на мобильных и просто для всех',
          desc: 'Оптимизировано для телефонов и touch‑управления для комфортного создания и сканирования.',
        },
        {
          title: 'Бесплатно навсегда, подходит для бизнеса',
          desc: 'Без аккаунта, без водяных знаков, без лимитов — надёжно для команд и компаний.',
        },
      ],
    },
    featureSuite: {
      title: 'Полный набор QR‑инструментов с упором на приватность',
      subtitle: 'Всё, что нужно для чистых, брендированных и качественных QR‑кодов — в одном месте.',
      categories: [
        {
          title: 'Все типы QR‑кодов, которые вам нужны',
          body: 'URL, Текст, Wi‑Fi, Email, Телефон, SMS, vCard, соцсети, YouTube, штрих‑коды. Статические коды, которые не истекают.',
          items: [],
        },
        {
          title: 'Брендинг и дизайн',
          body: 'Коды, безопасные для логотипа, градиенты, рамки, формы, углы и макеты, оптимизированные для сканирования.',
          items: [],
        },
        {
          title: 'Экспорт и качество',
          body: 'Экспорт в PNG, SVG и PDF высокого качества, с пресетами для печати и цифровых материалов.',
          items: [],
        },
        {
          title: 'Глобальность и удобство',
          body: 'Многоязычный интерфейс, mobile‑first дизайн и дружелюбная работа офлайн.',
          items: [],
        },
      ],
    },
    trust: {
      title: 'Нам доверяют создатели, команды и бренды',
      subtitle:
        'YesQRCode спроектирован как лёгкий, предсказуемый и безопасный инструмент для долгих кампаний — без аккаунтов, без привязки к вендору и без скрытых ограничений.',
      items: ['Без онбординга', 'Предсказуемые статические коды', 'Для компаний: без облачной обработки', 'Единый брендинг во всех материалах'],
    },
    sectionContent: 'Содержимое',
    sectionColors: 'Цвета',
    sectionLogo: 'Логотип',
    sectionFrame: 'Рамка',
    sectionDesign: 'Дизайн',
    sectionCorrection: 'Коррекция ошибок',
    labelUrl: 'URL сайта',
    labelText: 'Обычный текст',
    labelSsid: 'Имя сети (SSID)',
    labelPassword: 'Пароль',
    labelEncryption: 'Шифрование',
    labelFgColor: 'Передний план',
    labelBgColor: 'Фон',
    labelFrameText: 'Текст на рамке',
    labelFrameColor: 'Цвет рамки',
    placeholder: 'Введите содержимое...',
    placeholders: {
      url: 'https://example.com',
      text: 'Введите текст',
      email: 'you@email.com',
      subject: 'Тема',
      message: 'Ваше сообщение...',
      phone: '+7 999 123-45-67',
      ssid: 'MyWiFi',
      password: '***',
      barcode: '123456789012',
    },
    download: 'Скачать PNG',
    downloadSvg: 'Скачать SVG',
    generateButton: 'Создать QR‑код',
    copy: 'Копировать SVG',
    uploadLogo: 'Загрузить изображение',
    preview: 'Предпросмотр',
    lowQuality: 'Низкое качество',
    highQuality: 'Высокое качество',
    foreverFree: 'Бесплатно навсегда • Без регистрации • Для бизнеса',
    barcodeWarning: 'Расширенные опции дизайна (рамки, логотипы) недоступны для штрих‑кодов.',
    barcodeColors: 'Но вы всё равно можете настроить цвета ниже.',
    frameStyles: {
      none: 'Нет',
      simple: 'Простой',
      balloon: 'Пузырь',
      box: 'Бокс',
      badge: 'Бейдж',
      polaroid: 'Полароид',
      phone: 'Телефон',
      header: 'Заголовок',
      corner: 'Угол',
    },
    vCard: {
      firstName: 'Имя',
      lastName: 'Фамилия',
      mobile: 'Мобильный',
      phone: 'Телефон',
      fax: 'Факс',
      email: 'Email',
      company: 'Компания',
      job: 'Должность',
      street: 'Улица',
      city: 'Город',
      zip: 'Индекс',
      state: 'Регион',
      country: 'Страна',
      website: 'Сайт',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'Текст',
      [QRType.EMAIL]: 'Email',
      [QRType.PHONE]: 'Телефон',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'Wi‑Fi',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'Штрих‑код',
    },
    guide: {
      title: 'Как создать кастомный QR‑код?',
      steps: [],
    },
    gettingStarted: {
      title: 'Как пользоваться',
      steps: [
        {
          title: 'Задайте содержимое QR',
          text: 'Выберите тип содержимого сверху (URL, Текст, Email...). После выбора вы увидите доступные параметры. Заполните поля, которые должны отображаться при сканировании. Проверьте корректность ввода, потому что после печати изменить содержимое нельзя.',
        },
        {
          title: 'Настройте дизайн',
          text: 'Хотите уникальный QR‑код? Задайте свой цвет и замените стандартные формы. Углы и «тело» можно настраивать отдельно. Добавьте логотип: выберите из галереи или загрузите своё изображение.',
        },
        {
          title: 'Сгенерируйте QR‑код',
          text: 'Настройте разрешение в пикселях с помощью ползунка. Нажмите кнопки «Скачать», чтобы сохранить QR‑код. Обязательно проверьте его, отсканировав превью. Для печатного качества PNG используйте высокое разрешение.',
        },
        {
          title: 'Скачайте изображение',
          text: 'Скачайте QR‑код в .png, .svg или .pdf. Для векторного формата с полным дизайном выбирайте .svg. SVG открывается в Adobe Illustrator или Inkscape. Логотип и настройки дизайна сейчас работают только для .png и .svg.',
        },
      ],
    },
    about: {
      title: 'Бесплатный набор QR‑инструментов с упором на приватность',
      subtitle:
        'Генерируйте и сканируйте качественные QR‑коды без аккаунтов, водяных знаков и загрузки данных. Оптимизировано для печати, брендинга и коммерческого использования.',
      features: [
        'Все популярные типы: URL, Текст, Wi‑Fi, vCard, SMS и штрих‑коды',
        'Безопасно для логотипов — до 30% коррекции ошибок',
        'Кастомные формы, градиенты, цвета и рамки',
        'Статические QR‑коды, которые не истекают',
        'Многоязычный интерфейс для глобальных команд',
      ],
      content: [
        {
          title: 'QR‑коды, безопасные для логотипа',
          body: 'Добавляйте логотипы без страха, что код перестанет сканироваться. До 30% коррекции ошибок помогает сохранить читаемость на упаковке, меню и вывесках.',
        },
        {
          title: 'Кастомные формы и рамки',
          body: 'Меняйте формы углов, применяйте градиенты и выбирайте рамки под кампанию. Дизайн‑контролы помогают сохранить сканируемость и фирменный стиль.',
        },
        {
          title: 'Разные типы содержимого',
          body: 'Создавайте коды для URL, текста, Wi‑Fi, vCard, SMS и штрих‑кодов в одном месте — с пресетами для каждого формата.',
        },
        {
          title: 'Статические коды надолго',
          body: 'Создавайте статические QR‑коды без истечения срока и лимитов сканирования — идеально для длительных кампаний и печатных материалов.',
        },
      ],
    },
    faq: {
      title: 'Часто задаваемые вопросы',
      items: [
        {
          q: 'Что такое QR‑код?',
          a: 'QR расшифровывается как Quick Response Code и является видом штрих‑кода, изобретённым компанией Denso Wave в 1994 году.',
        },
        {
          q: 'Можно ли использовать сгенерированные QR‑коды в коммерческих целях?',
          a: 'Да. Все QR‑коды, созданные с помощью этого генератора, бесплатны и могут использоваться как угодно.',
        },
        {
          q: 'Истекают ли созданные QR‑коды?',
          a: 'Нет, они не истекают и будут работать всегда! QR‑коды, созданные в YesQRCode, статические и не перестают работать со временем. Но изменить содержимое после создания нельзя.',
        },
        {
          q: 'Есть ли лимит на количество сканирований?',
          a: 'Лимита нет, и созданный QR‑код будет работать всегда. Сканируйте сколько угодно!',
        },
        {
          q: 'Сохраняет ли YesQRCode мои данные?',
          a: 'Мы не сохраняем и не используем ваши данные. Для оптимизации производительности мы кэшируем файлы изображений QR‑кодов на 24 часа на нашем сервере.',
        },
        {
          q: 'Почему vCard QR‑код показывает неправильные поля?',
          a: 'Не все сканеры соблюдают официальный стандарт vCard, из‑за чего поля контакта могут «перемешиваться». Попробуйте другое приложение‑сканер для лучшего результата.',
        },
        {
          q: 'QR‑код не работает — что делать?',
          a: 'Причин может быть много. Сначала проверьте введённые данные — небольшие опечатки в URL ломают код. Некоторые коды (например vCard) содержат много данных: по возможности сократите их. Попробуйте убрать логотип и проверьте контраст: передний план должен быть темнее фона.',
        },
        {
          q: 'Работает ли YesQRCode во всех браузерах?',
          a: 'YesQRCode требует современный браузер с поддержкой HTML5 и официально поддерживает Chrome, Firefox, Safari, Edge и Internet Explorer 11.',
        },
      ],
    },
  },
  scanner: {
    title: 'Сканирование QR и штрих‑кодов',
    subtitle: 'Используйте камеру, загрузите изображение или вставьте из буфера, чтобы быстро распознать QR и штрих‑коды.',
    cameraPermission: 'Доступ к камере запрещён. Разрешите его в настройках браузера.',
    result: 'Результат',
    copy: 'Копировать',
    copied: 'Скопировано',
    open: 'Открыть ссылку',
    delete: 'Удалить',
    scanAgain: 'Сканировать ещё',
    privacy: 'Обработка происходит локально в вашем браузере. Файлы не покидают устройство.',
    upload: 'Загрузить изображение',
    paste: 'Вставить (Ctrl+V)',
    drop: 'Перетащите изображение сюда',
    retry: 'Повторить',
    errorAccessDenied: 'Доступ к камере запрещён',
    errorCamera: 'Разрешите доступ к камере в настройках браузера.',
    initializing: 'Инициализация камеры...',
    cameraActive: 'Камера активна',
    scannedItems: 'Отсканированные элементы',
    recentScans: 'Недавние (хранится локально)',
    clickToUpload: 'Нажмите, чтобы загрузить',
    newBadge: 'НОВОЕ',
    tabCameraMobile: 'Камера',
    tabCameraDesktop: 'Сканирование камерой',
    emptyState: {
      title: 'Пока нет сканов',
      desc: 'Загрузите изображение или используйте вкладку камеры, чтобы начать.',
    },
    highlights: {
      title: 'Быстро и приватно',
      items: [
        { title: 'Распознавание на устройстве', desc: 'По умолчанию без загрузок; безопасно для чувствительных URL и материалов.' },
        { title: 'Много форматов', desc: 'QR плюс UPC/EAN, Code 128, ITF и другие.' },
        { title: 'Быстрые действия', desc: 'Перетащите файлы, вставьте скриншот или мгновенно включите live‑скан.' },
        { title: 'Отлично на мобильных', desc: 'Интерфейс и работа с камерой оптимизированы для телефонов и небольших экранов.' },
      ],
    },
    intro: {
      title: 'Онлайн‑сканер QR и штрих‑кодов',
      body: 'Распознавайте QR‑коды, UPC, EAN и другое прямо в браузере без установки приложения.',
    },
    howTo: {
      title: 'Как сканировать?',
      methods: [
        {
          title: 'Способ 1: Загрузка',
          steps: ['Нажмите «Загрузить изображение»', 'Выберите QR/штрих‑код', 'Получите результат мгновенно'],
        },
        {
          title: 'Способ 2: Камера',
          steps: ['Откройте вкладку «Камера»', 'Разрешите доступ', 'Наводите на QR/штрих‑код'],
        },
      ],
    },
    features: {
      title: 'Почему этот сканер?',
      items: [
        { title: 'Локальная история', desc: 'Последние сканы сохраняются только на вашем устройстве — удобно копировать или открывать снова.' },
        { title: 'Распознавание изображений офлайн', desc: 'Загружайте или вставляйте изображения даже при перебоях связи.' },
        { title: 'Мгновенные действия', desc: 'Копируйте, открывайте или удаляйте результаты через удобные кнопки.' },
      ],
    },
    useCases: {
      title: 'Популярные сценарии',
      items: [
        { title: 'Ритейл и покупки', desc: 'Проверяйте URL товаров, купоны или инструкции.' },
        { title: 'Инвентаризация', desc: 'Проверяйте штрих‑коды и обновляйте складские данные.' },
        { title: 'Повседневные задачи', desc: 'Быстро открывайте меню, Wi‑Fi ссылки или визитки.' },
      ],
    },
    faq: {
      title: 'FAQ сканера',
      items: [
        { q: 'Можно ли сканировать штрих‑коды?', a: 'Да. Сканер поддерживает QR‑коды и Code 128, UPC, EAN, ITF и другие форматы.' },
        { q: 'Вы храните мои сканы?', a: 'Сканы не покидают браузер; всё остаётся на вашем устройстве.' },
        { q: 'Можно вставлять скриншоты?', a: 'Да. Нажмите Ctrl+V (Cmd+V), чтобы вставить из буфера обмена.' },
        { q: 'Работает офлайн?', a: 'Загрузка изображений работает офлайн; сканирование камерой требует разрешений и поддерживаемого браузера.' },
      ],
    },
  },
  blog: {
    title: 'Статьи и гайды',
    subtitle: 'Лучшие практики, идеи маркетинга и обновления продукта про QR‑опыт.',
    readMore: 'Читать',
    back: 'Назад к блогу',
    notFound: 'Пост не найден',
  },
  common: {
    footer: 'Мощный набор для создания QR‑кодов для маркетологов, дизайнеров и команд.',
    privacy: 'Приватность',
    terms: 'Условия',
    contact: 'Контакты',
    scanToOpen: 'Сканируйте, чтобы открыть на телефоне',
    help: 'Помощь',
    free: 'Бесплатно',
    product: 'Продукт',
    resources: 'Ресурсы',
    company: 'Компания',
    api: 'API (скоро)',
    systemStatus: 'Системы работают',
    footerDesc:
      'Самый продвинутый генератор и сканер QR‑кодов. Быстро, с упором на приватность и бесплатно навсегда для личного и коммерческого использования.',
  },
};

